import { ChatsCountModel } from '@/models/chat.model'
import { api } from '@/services/api'
import { FetchChatsCountDTO } from './types'

export async function fetchChatsCount(dto: FetchChatsCountDTO): Promise<ChatsCountModel> {
  const response = await api.post<{ chatsCount: ChatsCountModel }>('/mongo/chats/fetch-chats-count', dto)
  if (!response.data?.chatsCount) throw new Error('Missing chatsCount in response')
  return response.data.chatsCount
}
